import React, { useState } from 'react';
import { apiRequest } from '../config/api';

interface LikeButtonProps {
  targetType: 'flight' | 'comment';
  targetId: string;
  initialCount: number;
  initialLiked: boolean;
}

const LikeButton: React.FC<LikeButtonProps> = ({ targetType, targetId, initialCount, initialLiked }) => {
  const [liked, setLiked] = useState(initialLiked);
  const [count, setCount] = useState(initialCount);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    if (loading) return;

    // Optimistic update
    const newLiked = !liked;
    const newCount = newLiked ? count + 1 : count - 1;
    setLiked(newLiked);
    setCount(newCount);
    setLoading(true);

    try {
      const endpoint = targetType === 'flight'
        ? `/likes/flight/${targetId}`
        : `/likes/comment/${targetId}`;
      const res = await apiRequest(endpoint, { method: 'POST' });
      if (!res.ok) throw new Error('Request failed');
      const data = await res.json();
      setLiked(data.liked);
      setCount(data.count);
    } catch {
      // Rollback on error
      setLiked(liked);
      setCount(count);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      style={{
        background: 'none',
        border: 'none',
        cursor: loading ? 'default' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '2px 6px',
        borderRadius: '12px',
        color: liked ? '#4a90d9' : '#9aa0ad',
        fontWeight: liked ? 600 : 400,
        fontSize: '13px',
        transition: 'color 0.15s, background 0.15s',
      }}
      title={liked ? 'Gefällt mir nicht mehr' : 'Gefällt mir'}
    >
      <span style={{ fontSize: '15px', lineHeight: 1 }}>✈</span>
      {count > 0 && <span>{count}</span>}
    </button>
  );
};

export default LikeButton;
